import React, { useState } from 'react'
import { Table } from '../../admin/components/Table/Table'
import { PQRS } from '../../assets/icons'
import { Translate } from '../../language'
import Button from '../../utils/components/Button/Button'
import CheckButton from '../../utils/components/CheckButton/CheckButton'
import TitleSVG from '../../utils/components/TitleSVG/TitleSVG'

import style from './CreatePqrs.module.css'
const CreatePqrs = ({ formik, listPQRSUser }) => {

    const [typeValue, setTypeValue] = useState('petition');

    return (

        <div className="scroll-menu container-page">
            <div className="">
                <div className='mt-5'>
                    <TitleSVG Icon={PQRS} titleHighlight={'Peticiones '} title={'quejas, reclamos y sugerencias'} />
                </div>
                <div className={style.form_container} >
                    <div className={style.selector_container}>
                        <div className={style.title}>
                            <strong>Selecciona</strong> una categoría
                        </div>

                        <div>
                            <CheckButton name={'type'} textName={Translate("petition","es")} option={"petition"} formik={formik} value={formik.values.type} setValue={setTypeValue} />
                            <CheckButton name={'type'} textName={Translate("complaint","es")} option={"complaint"} formik={formik} value={formik.values.type} setValue={setTypeValue} />
                            <CheckButton name={'type'} textName={Translate("claim","es")} option={"claim"} formik={formik} value={formik.values.type} setValue={setTypeValue} />
                            <CheckButton name={'type'} textName={Translate("suggestion","es")} option={"suggestion"} formik={formik} value={formik.values.type} setValue={setTypeValue} />
                        </div>


                    </div>
                    <div>
                        <div className={`${style.description_container} mt-4`}>
                            <span className={`${style.subtitle} flex-1`}>
                                Titulo
                            </span>
                            <input className={`${style.input} flex-2`}
                                name="description" value={formik.values.description}
                                onChange={formik.handleChange} />

                        </div>
                        <div className={`${style.description_container} mt-4`}>

                            <span className={`${style.subtitle} flex-1`}>

                                Descripción
                            </span>
                            <textarea className={`${style.input_textarea} flex-2`}
                                name="petitionSubject" value={formik.values.petitionSubject}
                                onChange={formik.handleChange}
                            />
                        </div>



                        <div className={`${style.description_container} mt-1`}>
                            <span className={`${style.subtitle} flex-1`}>

                            </span>
                            <Button classNameContent={`${style.send_button} flex-2`} text='enviar' type='submit'
                                onClick={formik.handleSubmit} />
                        </div>

                    </div>

                </div>
                {(listPQRSUser?.lentgh!=0)&&<div className={`${style.form_container} mt-5`}>
                    <Table>
                        <thead>
                            <tr>
                            <th>
                                    Estado
                                </th>
                                <th>
                                    Tipo
                                </th>
                                <th>
                                    Titulo
                                </th>
                                <th>
                                    Asunto
                                </th>
                                <th>
                                    Respuesta
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listPQRSUser.map(prqrs => (
                                    <tr key={prqrs._id}>
                                         <td>{prqrs.status === 0 ? "Pendiente": prqrs.status === 1 ? "En espera":"Resuelta"   }</td>
                                        <td>{Translate(prqrs.type,"es")}</td>
                                        <td>{prqrs.description}</td>
                                        <td>{prqrs.petitionSubject}</td>
                                        <td>{prqrs.reply}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </div>}
            </div>
        </div>

    )
}

export default CreatePqrs